export default __webpack_public_path__ + "static/media/orangeSlab.ad35f9c0.svg";